import { render } from "./my-spacer-lg.vue?vue&type=template&id=630c29f4"
const script = {}

import exportComponent from "../../../accutrax-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__